import { Pagination, paginationToParams } from '../Pagination';

export interface BasketOwnerFilter {
  search?: string;
  pagination: Pagination;
}

export const basketOwnerFilterToParams = (
  basketOwnerFilter: BasketOwnerFilter,
) => ({
  search: basketOwnerFilter.search || undefined,
  ...paginationToParams(basketOwnerFilter.pagination),
});
